import { Typography } from '@aloft/toolkit-sui';

import React from 'react';

type Props = {
  helperText: string;
};

export const AdjustmentSettingsHelperText = ({ helperText }: Props) => (
  <Typography variant="body2" color="textSecondary">
    {helperText.split('\n').map((line) => (
      <React.Fragment key={line}>
        {line.trim()}
        <br />
      </React.Fragment>
    ))}
  </Typography>
);
